import { Button, FormControl, Grid, InputLabel, Select } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import SharedTitle from "routes/Pages/FichasTecnicas/Components/SharedForms/SharedTitle";
//import { ABIERTA, CERRADA, PRIVADOS, PUBLICOS } from 'config/config';
import RepresentantesCustomTable from "./RepresentantesCustomTable";
import ModalAddRepresentante from "./ModalAddRepresentante";
import { deleteRepresentante, getDataRepresentantes, getFichaTecnica, getProfesiones, patchRepresentante, postCreateRepresentante } from "services/api";
import { useLocation } from 'react-router-dom';
import Spinner from "@jumbo/components/custom/Spinner";
import { DESC_REPRESENTANTES, TEXT_COLOR_FT } from "config/config";
import { removeNulls } from "routes/Pages/FichasTecnicas/ConstsAndUtils/utils";
import { AddBoxOutlined } from "@material-ui/icons";


const Representantes2 = props => {

    const location = useLocation();

    const [isLoading, setIsLoading] = useState(false)
    const [agregarValue, setAgregarValue] = useState('0a')
    const [profesiones, setPRofesiones] = useState([])
    const [dataList, setDataList] = useState([])
    const [showModalCrear, setShowModalCrear] = useState(false)
    const [dataCrear, setDataCrear] = useState('')
    const [respresentantesList, setRepresentantesList] = useState([])

    const fields = [
        { id: 'nombre_completo', label: 'Nombre', type: 'text', shown: true },
        { id: 'nombre', label: 'Nombre', type: 'text', shown: false },
        { id: 'apellido_paterno', label: 'Apellido paterno', type: 'text', shown: false },
        { id: 'apellido_materno', label: ' Apellido materno', type: 'text', shown: false },
        { id: 'rut', label: 'RUT', type: 'rut', shown: true },
        { id: 'titulo', label: 'Tipo representante', type: 'none', shown: true },
        { id: 'profesion', label: 'Profesión', type: 'select', shown: true },
        { id: 'telefono', label: 'Teléfono contacto (Móvil)', type: 'phone', shown: true },
        { id: 'correo', label: 'Correo electrónico', type: 'mail', shown: true },
        { id: 'direccion', label: 'Domicilio', type: 'text', shown: false },

    ]

    useEffect(() => {
        getProfesiones()
            .then(res => {
                setPRofesiones(res.data)
            })
            .catch(e => console.error(e))
            .finally(f => {


            })
    }, [])

    useEffect(() => {
        setIsLoading(true)
        getData()
    }, [location])

    const getData = () => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        getFichaTecnica(user.organization.name)
            .then(res => {

                let representantes = res.data.autoridades.map((item, index) => {
                    if (!item.organigrama) {
                        return {
                            nombre_completo: item.nombres + ' ' + item.apellido_paterno + ' ' + item.apellido_materno,
                            apellido_materno: item.apellido_materno ? item.apellido_materno : '',
                            apellido_paterno: item.apellido_paterno ? item.apellido_paterno : '',
                            titulo: item.cargo,
                            correo: item.correo,
                            direccion: item.domicilio ? item.domicilio : '',
                            id: item.id,
                            id_prestador: item.id_prestador,
                            profesion: item.id_profesion,
                            nombre: item.nombres,
                            rut: item.rut,
                            rut_prestador: item.rut_prestador,
                            telefono: item.tlf_movil ? item.tlf_movil : ''
                        }
                    } else {
                        return null
                    }

                })

                setDataList(removeNulls(representantes))
                getDataRepresentantes(res.data.identidad.id_tipo_administracion, res.data.identidad.id_tipo_atencion)
                    .then(res2 => {
                        let aux = res2.data.map((item) => {
                            if (!item.organigrama) {
                                return item
                            } else {
                                return null
                            }
                        })
                        setRepresentantesList(removeNulls(aux))
                    })
                    .catch(e => console.error(e))
                    .finally(ff => {

                    })
            })
            .catch(e => console.error(e))
            .finally(f => {
                setIsLoading(false)


            })
    }

    const closeModalCrear = () => {
        setDataCrear(
            {
                nombre: '',
                apellido_paterno: '',
                apellido_materno: '',
                rut: '',
                profesion: '',
                telefono: '',
                correo: '',
                direccion: '',
                titulo: '',
            })
        setAgregarValue('0a')
        setShowModalCrear(false)
    }


    const postData = (data) => {

        setIsLoading(true)
        let cargo = respresentantesList.find(e => e.nombre_tipo_autoridad === data.titulo)
        const prestadorData = JSON.parse(sessionStorage.getItem('prft'))
        let prepareData = {
            id_prestador: prestadorData.i,
            rut_prestador: prestadorData.r,
            nombres: data.nombre,
            apellido_paterno: data.apellido_paterno,
            apellido_materno: data.apellido_materno,
            rut: data.rut,
            cargo: cargo.nombre_tipo_autoridad,
            correo: data.correo,
            id_profesion: data.profesion,
            domicilio: data.direccion,
            tlf_movil: data.telefono,
        }

        postCreateRepresentante(prepareData)
            .then(res => {

            })
            .catch(e => console.error(e))
            .finally(f => {
                //setIsLoading(false)
                getData()
            })
    }

    const save = (data) => {

        setIsLoading(true)
        let cargo = respresentantesList.find(e => e.nombre_tipo_autoridad.toLowerCase() === data.titulo.toLowerCase())
        const prestadorData = JSON.parse(sessionStorage.getItem('prft'))
        let prepareData = {
            id: data.id,
            tlf_movil: data.telefono ? data.telefono : '',
            id_prestador: prestadorData.i,
            rut_prestador: prestadorData.r,
            nombres: data.nombre,
            apellido_paterno: data.apellido_paterno,
            apellido_materno: data.apellido_materno,
            rut: data.rut,
            cargo: cargo.nombre_tipo_autoridad,
            correo: data.correo,
            id_profesion: data.profesion,
            domicilio: data.direccion
        }

        patchRepresentante(prepareData.id, prepareData)
            .then(
                res => {

                })
            .catch(e => console.error(e))
            .finally(f => {
                getData()
            })

    }

    const dilit = (data) => {
        setIsLoading(true)
        deleteRepresentante(data.id)
            .then(res => {

            })
            .catch(e => console.error(e))
            .finally(f => {
                getData()
            })
    }

    const addRepresentante = () => {

        let tit = respresentantesList.find(e => e.id === parseInt(agregarValue))
        let auxRep = {
            nombre: '',
            apellido_paterno: '',
            apellido_materno: '',
            rut: '',
            profesion: '',
            telefono: '',
            correo: '',
            direccion: '',
            titulo: tit.nombre_tipo_autoridad
        }

        setDataCrear(auxRep)
        setShowModalCrear(true)
    }

    /*     const getRepresentantesPorCargo = () => {
    
            const camposRepresentados = respresentantesList.filter(rep => dataList.some(item => item.titulo === rep.nombre_tipo_autoridad))
    
    
            return camposRepresentados.map((item, index) => {
    
                return <RepresentantesCustomTable
                    key={index}
                    title={item.nombre_tipo_autoridad}
                    cargo={item.nombre_tipo_autoridad}
                    headCells={fields}
                    profesiones={profesiones}
                    rows={dataList}
                    handleSave={save}
                    handleDelete={dilit}
                    fields={fields}
                />
            })
        } */

    return (
        <>
            <div style={{ width: '100%', flexBasis: '100%', color: TEXT_COLOR_FT, backgroundColor: 'white' }} elevation={1}>
                <Spinner show={isLoading} />
                <SharedTitle
                    title={'Representantes / Encargados'}
                />
                <Grid item xs={12} sm={12} md={12} style={{ paddingLeft: 25, paddingTop: 15, paddingBottom: 15 }}>
                    <p>{DESC_REPRESENTANTES}</p>
                </Grid>

                <Grid container item xs={12} spacing={4} style={{ paddingLeft: 25 }}>
                    <Grid item xs={6}>
                        <FormControl size='small' fullWidth>
                            <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                                {'Tipo de representante'}
                            </InputLabel>
                            <Select
                                native
                                id="grouped-native-select"
                                fullWidth
                                variant='outlined'
                                label={'Tipo de representante'}
                                value={agregarValue}
                                onChange={(e) => {
                                    setAgregarValue(e.target.value)
                                }}
                            >
                                <option key={0} value={'0a'}>
                                    {'Seleccione'}
                                </option>
                                {
                                    //getOptions()
                                }
                                {respresentantesList.map((item, index) => {

                                    return <option key={index} value={item.id}>{item.nombre_tipo_autoridad}</option>
                                })}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={4}>
                        <Button
                            startIcon={<AddBoxOutlined />}
                            disabled={agregarValue === '0a' ? true : false}
                            fullWidth
                            color="primary"
                            variant="outlined"
                            style={{ marginTop: 2 }}
                            onClick={() => { addRepresentante() }}
                        >
                            Agregar representante
                        </Button>
                    </Grid>

                </Grid>

                {//getRepresentantesPorCargo()
                }
                {
                    dataList.length > 0 ?
                        <RepresentantesCustomTable
                            title={''}
                            cargo={''}
                            headCells={fields}
                            profesiones={profesiones}
                            rows={dataList}
                            handleSave={save}
                            handleDelete={dilit}
                            fields={fields}
                        />
                        :
                        null

                }

            </div>
            <ModalAddRepresentante
                openDialog={showModalCrear}
                close={closeModalCrear}
                dataCrear={dataCrear}
                fields={fields}
                setDataCrear={setDataCrear}
                postData={postData}
                profesiones={profesiones}
            />

        </>
    )
}

export default Representantes2